import React from 'react';
import PropTypes from 'prop-types';

import View from './SuccessFailure.view';

const SuccessFailure = props => {

	const { result } = props;
	const { hasResult, ...viewProps } = props;

	if (!hasResult) {
		return null;
	}

	if (result === null) {
		return null;
	}

	return <View {...viewProps} />;
};

SuccessFailure.propTypes = {
	result: PropTypes.bool,
	hasResult: PropTypes.bool,
	successMessage: PropTypes.string,
	failMessage: PropTypes.string
};

SuccessFailure.defaultProps = {
	result: null,
	hasResult: false,
	successMessage: 'Success',
	failMessage: 'An error occurred'
};

export default SuccessFailure;
